var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72733 27C1.22321 27 1.06651e-07 25.789 2.37795e-07 24.2999L1.66457e-06 8.09959C1.79571e-06 6.61051 1.22321 5.39953 2.72733 5.39953L17.3574 5.39953L14.6301 8.09959L2.72733 8.09959L2.72733 24.2999L24.5459 24.2999L24.5433 12.5188L27.2733 9.81877L27.2733 24.2999C27.2733 25.789 26.0501 27 24.5459 27L2.72733 27ZM15.0003 14.8497L15.0003 11.5511L23.5791 3.05808L26.911 6.35932L18.3322 14.8497L15.0003 14.8497ZM28.0909 5.19123L24.7564 1.88998L26.4236 0.241999C26.7496 -0.0806595 27.2763 -0.0806594 27.6009 0.241999L29.7556 2.37515C30.0815 2.69781 30.0815 3.2193 29.7556 3.54061L28.0909 5.19123Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.508c1e516174e1d99aba5ef81b3d4186.svg";
export { ForwardRef as ReactComponent };